import { clamp } from '../../utilities/clamp';

const DEFAULT_REG_FITMENT = 4;
const MIN_REG_FITMENT = 1;
const MAX_REG_FITMENT = 8;

const DEFAULT_SPLIT_FITMENT = 2;
const MIN_SPLIT_FITMENT = 0;
const MAX_SPLIT_FITMENT = 4;

export const validInitialTireQuantities = ({ qtyFront, qtyRear }) => {
  let frontQty = window.drupalSettings?.vehicleInformation?.splitFitment
    ? DEFAULT_SPLIT_FITMENT
    : DEFAULT_REG_FITMENT;
  if (window.drupalSettings?.searchResults?.products
    && window.drupalSettings?.searchResults?.products[0]?.category === 'Trailer Tires') {
    frontQty = DEFAULT_SPLIT_FITMENT;
  }

  return {
    qtyFront: clamp(qtyFront ?? frontQty, {
      min: MIN_REG_FITMENT,
      max: MAX_REG_FITMENT,
    }),
    qtyRear: clamp(qtyRear ?? DEFAULT_SPLIT_FITMENT, {
      min: MIN_SPLIT_FITMENT,
      max: MAX_SPLIT_FITMENT,
    }),
  };
};

export const tireInfo = ({ isSplitFitment, isFrontTire }) => {
  if (!isSplitFitment) {
    return {
      minQuantity: MIN_REG_FITMENT,
      maxQuantity: MAX_REG_FITMENT,
      label: 'Quantity',
    };
  }

  return {
    minQuantity: MIN_SPLIT_FITMENT,
    maxQuantity: MAX_SPLIT_FITMENT,
    label: isFrontTire ? 'Front Tire Quantity' : 'Rear Tire Quantity',
  };
};
